export default __webpack_public_path__ + "static/media/how-does-it-work.4c8c19ab.svg";